import { useEffect } from 'react';
import { useOptionalSession } from 'src/contexts/SessionContext';

export interface MetaProps {
  title: string;
  brand?: string;
}

export const Meta: React.FC<MetaProps> = (props) => {
  const { title, brand } = props;

  const { session } = useOptionalSession();

  const fullTitle = title
    ? `${title} - ${brand || session?.brand || 'Exercise.com'}`
    : `${brand || session?.brand || 'Exercise.com'}`;

  useEffect(() => {
    document.title = fullTitle;
  }, [fullTitle]);

  return null;
};
